import { TenantSettingListMaintenanceDto } from '@shared/src/controllers/maintenance/tenant/TenantSettingListMaintenanceDto';

export class TenantSettingCategoryEntry {
    public setting: TenantSettingListMaintenanceDto;
    public order: number;
}

/***
 * Un node de l'arbre de classificació de TenantSettings. Es construeix a
 * partir del valor de TENANTSETTING.<KEY>.CLASSIFICATION de cada setting
 * (p.e. "SLOTS#5;PERSONALIZATION,USER,LANGUAGE"): cada segment separat per
 * "," és un nivell de l'arbre, "#N" opcional fixa la posició del setting
 * DINS d'aquell node concret, i "," separats per ";" són camins
 * independents (el mateix setting apareix a més d'un lloc de l'arbre).
 */
export class TenantSettingCategoryNode {
    public id: string;
    public caption: string;
    public children: TenantSettingCategoryNode[] = [];
    public entries: TenantSettingCategoryEntry[] = [];
    public expanded: boolean = false;

    public findOrCreateChild(id: string): TenantSettingCategoryNode {
        let child = this.children.find(c => c.id === id);
        if (child == null) {
            child = new TenantSettingCategoryNode();
            child.id = id;
            child.caption = id;
            this.children.push(child);
        }
        return child;
    }

    public sortChildren() {
        this.children.sort((a, b) => a.caption.localeCompare(b.caption));
        this.children.forEach(c => c.sortChildren());
        this.entries.sort((a, b) => {
            if (a.order != null && b.order != null && a.order !== b.order)
                return a.order - b.order;
            if (a.order != null && b.order == null)
                return -1;
            if (a.order == null && b.order != null)
                return 1;
            return a.setting.setting.toString().localeCompare(b.setting.setting.toString());
        });
    }

    // Nombre total de settings a aquest node i a tots els seus descendents (per mostrar comptadors i per la cerca)
    public totalEntryCount(): number {
        return this.entries.length + this.children.reduce((sum, c) => sum + c.totalEntryCount(), 0);
    }
}
